import { Box, Flex, Stack, Title, Text, Image } from '@mantine/core';
import { ForeColorYellow, ForeColorWhite } from "../../lib/constants";
import { useRef, useEffect, useState } from 'react';
import { useWindowScroll, useMediaQuery } from '@mantine/hooks';

function AboutUs() {
  const aboutUsImg = "img/aboutus/aboutus-image.jpg";
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const isMobile = useMediaQuery('(max-width: 768px)');

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <Box id="aboutUs" bg="white" w="100%">
      <Flex direction={isMobile ? "column" : "row-reverse"} ref={sectionRef}>
        {/* Image */}
        <Image
          src={aboutUsImg}
          id="chooseUs-art"
          maw={{ lg: 800, md: 400 }}
          w={{ lg: '50%', md: 400 }}
          visibleFrom="md"
        />

        {/* Text */}
        <Stack
          mih={isMobile ? "auto" : "80vh"}
          id="chooseUs-contents"
          bg={ForeColorYellow}
          align="flex-start"
          w="100%"
          gap="xl"
          py={isMobile ? "60px" : "10%"}
        >
          <Flex align="start" justify="center" direction="column" px={isMobile ? "24px" : "20%"} gap={25}>
            <Title
              order={4}
              style={{
                textAlign: "left",
                color: ForeColorWhite,
                fontWeight: 600,
                fontSize: isMobile ? 24:36,
              }}
              className={visible ? 'fade-text delay-0' : 'text-hidden'}
            >
              About Us
            </Title>

            <Text className={visible ? 'fade-text delay-1' : 'text-hidden'} style={{ textAlign: "left", color: ForeColorWhite, fontSize: "1.125rem" }}>
              Established in 1992, Global Comfort Group Corporation (GCGC) is a premier multi-brand hotel management company, dedicated to delivering superior hospitality experiences across the Philippines. With a diversified portfolio ranging from budget-friendly accommodations to upscale luxury hotels, GCGC has become a trusted name in the lodging industry.
            </Text>

            <Text className={visible ? 'fade-text delay-2' : 'text-hidden'} style={{ textAlign: "left", color: ForeColorWhite }}>
              Our business is built upon a strong foundation of Cleanliness, Innovation, Efficiency, Courtesy, Discipline, and Teamwork, values that continue to shape the guest experience we proudly offer. With over 4,000 hotel rooms under management, we are committed to exceeding guest expectations through genuine, timely, and reliable service that simply outperforms the competition.
            </Text>

            <Text className={visible ? 'fade-text delay-3' : 'text-hidden'} style={{ textAlign: "left", color: ForeColorWhite }}>
              GCGC thrives on a culture of service excellence and innovation, continuously growing its footprint through real estate development, property management, commercial leasing, and strategic site acquisitions. As we move forward, we remain steadfast in our mission to enhance the lives of our guests, employees, and the communities we serve.
            </Text>

         
          </Flex>
        </Stack>
      </Flex>
    </Box>
  );
}

export default AboutUs;
